var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option-selection',{staticClass:"mt-4",attrs:{"allow-custom-choice":_vm.question.settings.hasOtherOption,"is-multiple-choice":"","options":_vm.question.options},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }